import { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import footerBgFooterLogoImg from '@/assets/images/footer.png'
import footerLogoFooterLogoImg from '@/assets/images/footer_logo.png'
import playStoreBlackIcon from '@/assets/images/icon_playstore.png'
import { BLOG_URL, DATAU_URL, STORE_URL } from '@/shared/constants'
import { Nanum_b_size, Nanum_eb_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'
import { bgSet, icoSet } from '@/styles/mixins'

const Footer = forwardRef<HTMLAnchorElement, unknown>((_, ref) => {
  return (
    <FooterWrap>
      <FooterAppDownSection>
        <FooterServiceDesc>
          내 소중한 휴대폰,
          <br />
          분실 전에 미리 설치하고 보호하세요!
        </FooterServiceDesc>

        <FooterAppDownLink target="_blank" href={STORE_URL} ref={ref}>
          다운로드 받기
        </FooterAppDownLink>
      </FooterAppDownSection>
      <FooterInfoSection>
        <FooterServiceMenu>
          <Link to={DATAU_URL} target="_blank">
            회사소개
          </Link>
          <Link to={'/terms/10/1'}>이용약관</Link>
          <Link to={'/terms/10/2'}>개인정보처리방침</Link>
          <Link to={BLOG_URL} target="_blank">
            서비스 블로그
          </Link>
        </FooterServiceMenu>
        <FooterLogoImg src={footerLogoFooterLogoImg} />
        <FooterBusinessInfo>
          (주)데이터유니버스 대표 : 강원석 | 서울특별시 영등포구 여의대로 70 원센티널 10층
          <br />
          고객지원센터 :1811-4031 (공휴일 휴무 09:00 ~ 12:00 / 13:00 ~ 18:00)
          <br />
          Copyright © 2020 DataUniverse. All Rights Reserved.
        </FooterBusinessInfo>
      </FooterInfoSection>
    </FooterWrap>
  )
})

Footer.displayName = 'Footer'

export default Footer

const FooterWrap = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`
const FooterAppDownSection = styled.section`
  background-image: url(${footerBgFooterLogoImg});
  background-size: cover;
  padding: 104px 22%;
  ${bgSet}
  width: 100%;

  ${mediaTablet} {
    padding: 116px 18% 83px;
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`
const FooterAppDownLink = styled.a`
  padding: 13px 26px;
  border-radius: 30px;
  background-color: var(--white);
  display: inline-flex;
  ${Nanum_eb_size(20)}

  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 21px;
    height: 23px;
    margin-right: 13px;
    ${icoSet};
    background-image: url(${playStoreBlackIcon});
  }

  ${mediaTablet} {
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 13px;
    &:before {
      width: 13px;
      height: 14px;
      margin-right: 10px;
    }
  }
`
const FooterInfoSection = styled.section`
  padding: 40px 0 100px;
  text-align: center;

  ${mediaTablet} {
    padding: 30px 0 64px;
  }
`
const FooterServiceDesc = styled.p`
  ${Nanum_b_size(30)}
  color: var(--white);
  line-height: 1.6;
  margin-bottom: 37px;

  ${mediaTablet} {
    font-size: 20px;
    margin-bottom: 17px;
  }
`
const FooterServiceMenu = styled.menu`
  a {
    ${Nanum_b_size(16)}
    padding: 0 20px;
    border-left: 1px solid var(--black);
  }

  a:first-child {
    border-left: none;
  }

  ${mediaTablet} {
    a {
      font-size: 12px;
      padding: 0 10px;
    }
  }
`

const FooterLogoImg = styled.img`
  width: 198px;
  height: 53px;
  margin: 36px auto;
  ${icoSet}

  ${mediaTablet} {
    width: 130px;
    height: 35px;
    margin: 16px auto;
  }
`
const FooterBusinessInfo = styled.p`
  ${Nanum_b_size(12)}
  line-height: 1.6;
  color: var(--gray-4f);

  ${mediaTablet} {
    font-size: 8px;
  }
`
